import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';

let purposeSwiperWr = document.querySelectorAll('.purpose-swiper-wr');
purposeSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesArr = el.querySelectorAll('.swiper-slide');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');
    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation],
      observer: true,
      observeParents: true,
      spaceBetween: 10,
      slidesPerView: 1,
      threshold: 10,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        1025: {
          slidesPerView: 4,
        },
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 640,
      },
    });
    swiperObserver(swiper);

    setTimeout(function () {
      let maxHeight = 0;

      slidesArr.forEach((slide) => {
        const height = slide.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
      });

      slidesArr.forEach((slide) => {
        slide.style.minHeight = maxHeight + 'px';
      });

      slidesArr.forEach((slide) => {
        const clearClasses = () => {
          slidesArr.forEach((el) =>
            el.classList.remove('is-active', 'is-prev', 'is-next')
          );
        };

        slide.addEventListener('mouseenter', () => {
          clearClasses();

          slide.classList.add('is-active');

          slide.nextElementSibling?.classList.add('is-next');
          slide.previousElementSibling?.classList.add('is-prev');
        });

        slide.addEventListener('mouseleave', clearClasses);
      });
    }, 300);
  }
});
